export default "__VITE_ASSET__D69qthR4__";